import type { ReactNode } from 'react'
import { Card } from './Card'
import { Badge } from './Badge'
import { cn } from '../../lib/utils'

interface MetricCardProps {
  label: string
  value: ReactNode
  delta?: string
  icon?: ReactNode
  tone?: 'default' | 'success' | 'warning' | 'danger' | 'info'
  className?: string
}

export function MetricCard({ label, value, delta, icon, tone = 'default', className }: MetricCardProps) {
  return (
    <Card padding="md" className={cn('metric-card', `metric-card-${tone}`, className)}>
      <div className="metric-card-header">
        <span className="caption metric-card-label">{label}</span>
        {icon && <span className="metric-card-icon">{icon}</span>}
      </div>
      <div className="metric-card-value">{value}</div>
      {delta && <Badge tone={tone === 'default' ? 'neutral' : tone}>{delta}</Badge>}
    </Card>
  )
}
